import * as React from 'react';
import { ApplicationProvider as ThemeProviderLib } from '@ui-kitten/components';
import * as eva from '@eva-design/eva';

import { myTheme } from '../theme/theme';

export const ThemeProvider = ({ children }: { children?: React.ReactNode }) => (
	<ThemeProviderLib {...eva} theme={myTheme}>
		{children}
	</ThemeProviderLib>
);
